import { Controller } from "stimulus";

export default class extends Controller {
  connect() {
    $(this.element.nextElementSibling.querySelector(".contract-details"))
      .on("show.bs.collapse", () => {
        this.element.classList.add("border-bottom");
        this.element.classList.add("open");
        this.element.nextElementSibling.classList.add("open");
      })
      .on("hide.bs.collapse", () => {
        this.element.classList.remove("border-bottom");
        this.element.classList.remove("open");
        this.element.nextElementSibling.classList.remove("open");
      });
  }
}
